import { useMutation, type DefaultError } from "@tanstack/react-query"
import { Creators } from "model/deleter"
import { useDispatch } from "react-redux"

interface DeletePinnedWorkflowPayload {
  accountAlias: string
  pinnedId: string
}

/**
 * Hook to delete a pinned AI workflow
 * Note: This uses Creators.del from model/deleter which doesn't accept callbacks so the promise resolves
 * before the delete saga runs which means errors are never caught and the caller in useRemoveArtifactHandler
 * will always think the delete succeeded.
 * TODO[APP-2438]: Do we want to fix this to provide better errors to the caller
 */
export function useDeletePinnedWorkflow() {
  const dispatch = useDispatch()

  return useMutation<unknown, DefaultError, DeletePinnedWorkflowPayload>({
    mutationFn: ({ accountAlias, pinnedId }) => {
      return new Promise<void>((resolve) => {
        dispatch(Creators.del(
          "pinned-workflow",
          `/api/${accountAlias}/ai/delete-pinned-workflow/${pinnedId}`,
          pinnedId,
          { onSuccess: "", onError: "" },
        ))
        resolve(undefined)
      })
    },
  })
}
